module.exports = __webpack_public_path__ + "img/key-selected.f0e3447a.png";